import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDms} from '../DM/FormChooseDm.jsx'
import Model from './ModelCdg.mjs'

export const FormItemPcdgName = props => (
    <FormItemBizProp
        Model={Model}
        prop="pcdgName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemPcdgUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="pcdgUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseCdg(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDms />
            <FormItemPcdgUserCode />
            <FormItemPcdgName />
        </FormChooseDesign>
    )
}
